const animator = {

	animationObserver : null,
	elem: document.querySelectorAll('.inactive'),

	animate(entries) {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
				entry.target.classList.remove('inactive');
				animator.animationObserver.unobserve(entry.target);
			}
		});
	},	

	init() {
		animator.animationObserver = new IntersectionObserver(animator.animate, { root: null, rootMargin: '-25% 0px', threshold: 0 });

		animator.elem.forEach(function(element) {
			animator.animationObserver.observe(element);
		});
	}

};

export { animator };




